<ngb-alert
  *ngIf="alert?.show"
  class="notify"
  [type]="alert?.type"
  [dismissible]="true"
  (closed)="onAlertClosed()"
>
  <p style="margin-bottom: 0">{{ alert?.message }}</p>
</ngb-alert>
